/** Admin access grants are independent of store payments and never auto-renew. */
export type ManualAccessDuration = { kind: 'months'; months: number } | { kind: 'lifetime' };
export type AdminPlanGrant =
  | { planTier: 'ember' }
  | { planTier: 'flame' | 'blaze'; duration: ManualAccessDuration };

export interface AdminSubscription {
  source: 'free' | 'manual' | 'revenuecat';
  status: 'free' | 'active' | 'expired';
  store: string | null;
  accessUntil: string | null;
  isLifetime: boolean;
  canManageManually: boolean;
}

/** Effective benefits are separate from the personally owned, editable subscription. */
export interface AdminUserAccess {
  partner: { id: string; name: string | null; email: string } | null;
  effectiveSubscription: {
    planTier: 'ember' | 'flame' | 'blaze';
    source: 'free' | 'manual' | 'revenuecat' | 'partner';
    access: AdminSubscription;
  };
}

/** Calendar months in UTC, clamped to the last day of a shorter target month. */
export function manualAccessEnd(start: Date, duration: ManualAccessDuration): Date | null {
  if (duration.kind === 'lifetime') return null;
  if (!Number.isInteger(duration.months) || duration.months < 1 || duration.months > 120) {
    throw new RangeError('Access duration must be between 1 and 120 months');
  }
  const end = new Date(start);
  const day = end.getUTCDate();
  end.setUTCDate(1);
  end.setUTCMonth(end.getUTCMonth() + duration.months);
  const lastDay = new Date(Date.UTC(end.getUTCFullYear(), end.getUTCMonth() + 1, 0)).getUTCDate();
  end.setUTCDate(Math.min(day, lastDay));
  return end;
}
